import { useContext, useEffect, useState } from "react";
import { Check } from "react-feather";
import { BannerContext } from "../../InternalApiApp";
import { useRemote } from '../../Utils/Utils';
import Divider from "../../components/Divider";
import Button from "../../components/Buttons/Button";
import Tooltip from "../../components/popups/Tooltip";
import "./AnalyticsSourceSelector.scss";

const AnalyticsSourceSelector = ({ }) => {
    const { bannerAdditionalInfo, setBannerAdditionalInfo } = useContext(BannerContext);
    const remote = useRemote();
    const [editing, setEditing] = useState(false)
    const [platforms, setPlatforms] = useState([])
    const [saveButtonActive, setSaveButtonActive] = useState(false)
    const [tags, setTags] = useState([])
    const [forceClose, setForceClose] = useState(false)


    useEffect(() => {
        if (bannerAdditionalInfo) {
            const tagArr = bannerAdditionalInfo.platforms.map(platform => platform.products.map(pro => ({ name: pro.name, selected: pro.selected })).filter(product => product.selected)).flat().map(p => p.name)
            setPlatforms(bannerAdditionalInfo.platforms)
            setTags(tagArr)
        }
    }, [bannerAdditionalInfo])

    useEffect(() => {
        remote.get("/analytics/filters").then((filters) => {
            const savedSelections = localStorage.getItem("3skye.analytics.selection");
            if (savedSelections) {
                const saved = JSON.parse(savedSelections);
                // Build a lookup of saved selection state by product id
                const savedById = {};
                saved.platforms.forEach(p =>
                    p.products.forEach(prod => { savedById[prod.id] = prod.selected; })
                );
                // Merge: use API structure, apply saved selected state where product still exists
                const merged = {
                    platforms: filters.platforms.map(platform => ({
                        ...platform,
                        products: platform.products.map(prod => ({
                            ...prod,
                            selected: savedById[prod.id] !== undefined ? savedById[prod.id] : prod.selected
                        }))
                    }))
                };
                setBannerAdditionalInfo(merged);
                // Update localStorage to remove stale products
                localStorage.setItem("3skye.analytics.selection", JSON.stringify(merged));
            } else {
                setBannerAdditionalInfo(filters);
            }
        }).catch((error) => {
            // Fall back to saved selections if API fails (or the saved JSON above was malformed);
            // otherwise resolve to "no filter" so pages that wait for the filter before fetching
            // (Analytics → Videos) still load. Never let a bad localStorage value leave it unresolved.
            let saved = null;
            try {
                const savedSelections = localStorage.getItem("3skye.analytics.selection");
                saved = savedSelections ? JSON.parse(savedSelections) : null;
            } catch (parseError) {
                localStorage.removeItem("3skye.analytics.selection");
            }
            setBannerAdditionalInfo(saved && saved.platforms ? saved : { platforms: [] });
            console.log("Error on filter call", error);
        });

        document.addEventListener("mousedown", handleClickAway)
        return () => document.removeEventListener("mousedown", handleClickAway)
    }, [])

    useEffect(() => {
        if (forceClose && editing) {
            setEditing(false)
        }
    }, [forceClose])

    function handleClickAway(e) {
        const currentElementClass = e.target.className || null
        const parentElement = e.target.parentElement
        const parentClass = parentElement && parentElement.className || null
        const grandpaElement = parentElement.parentElement || null
        const grandpaClass = grandpaElement.className || null
        const classessNamesArray = [currentElementClass, parentClass, grandpaClass].filter(e => e !== null)

        if ((currentElementClass && typeof currentElementClass === 'string' && currentElementClass.includes("source-selector-dropdown")) || (parentClass && typeof parentClass === 'string' && parentClass.includes('source-selector-dropdown'))) {
            setForceClose(true)
        } else if (classessNamesArray.length > 0 && classessNamesArray.includes('source-selector-menu')) {
            return null
        } else {
            setForceClose(true)
            setForceClose(false)
            setForceClose(true)
        }
    }


    function updateSelection(index) {
        const newArr = platforms.map((platform) => {
            return {
                name: platform.name,
                products: platform.products.map((acc) => {
                    if (acc.id === index) return { ...acc, selected: !acc.selected }
                    else return acc
                })
            }
        })

        setBannerAdditionalInfo({ platforms: newArr })
        setSaveButtonActive(true)
    }

    function triggerMenu() {
        setEditing(!editing)
    }

    function saveDefaultSelection() {
        console.log("Save button pressed")
        localStorage.setItem("3skye.analytics.selection", JSON.stringify({ platforms: platforms }))
        setSaveButtonActive(false)
    }

    return (
        <div className="source-selector-wrapper">
            <Tooltip
                innerStyle={{ padding: '0.5rem 0.75rem' }}
                label={
                    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', fontSize: '0.85rem', paddingRight: '0.5rem' }}>
                        {tags?.length > 0 ?
                          tags.join(", ") : "All" }
                    </div> 
                }
            >
                <div className={`source-selector-dropdown${editing ? ' active' : ''}`} onClick={triggerMenu}>
                    <i className="material-icons">filter_list</i>
                </div>
            </Tooltip>
            {editing && <div className="source-selector-menu" id="source-selector-menu">
                <label>All Products</label>
                <Divider />
                {platforms?.map((platform, platformIdx) =>
                    <>
                        <div key={`platform-${platformIdx}`} className="section-header">{platform.name}</div>
                        {platform?.products?.map((acc, idx) =>
                            <div key={acc.name + "-" + idx} className="source-menu-option" onClick={() => { updateSelection(acc.id) }}>
                                <label>{acc.name}</label>
                                {acc.selected && <Check size={16} className='colour-text-primary' />}
                            </div>
                        )
                        }
                    </>
                )}

                <Divider />
                {/* <div className="section-header">FirstChoice</div>
                    <div className="source-menu-option" onClick={() => { updateSelection(3) }}>
                        <label>{products[3].name}</label>
                        {products[3].selected && <Check size={16} className='colour-text-primary' />}
                    </div>
                    <Divider /> */}
                <Button variant='secondary' onClick={saveDefaultSelection} disabled={!saveButtonActive}>Save as default view</Button>
            </div >
            }

        </div>
    )
}

export default AnalyticsSourceSelector